export function buildPathWithSearch(pathname, search = '') {
  return `${pathname || ''}${search || ''}`;
}

export function appendWorkspaceReturnContext(target, currentPathWithSearch, currentLabel) {
  if (!target) return target;
  const url = new URL(target, 'http://workspace.local');
  if (currentPathWithSearch) {
    url.searchParams.set('returnTo', currentPathWithSearch);
  }
  if (currentLabel) {
    url.searchParams.set('returnLabel', currentLabel);
  }
  const query = url.searchParams.toString();
  return `${url.pathname}${query ? `?${query}` : ''}${url.hash || ''}`;
}

export function buildWorkspaceReturnTarget(location) {
  if (!location) return '';
  return buildPathWithSearch(encodeURI(location.pathname || ''), location.search);
}

export function getWorkspaceReturnContext(searchParams) {
  return {
    returnTo: searchParams?.get('returnTo') || '',
    returnLabel: searchParams?.get('returnLabel') || 'Return',
  };
}

export function prependWorkspaceBreadcrumb(baseItems, searchParams) {
  const { returnTo, returnLabel } = getWorkspaceReturnContext(searchParams);
  if (!returnTo) return baseItems;
  if (baseItems.some((item) => item?.to === returnTo)) return baseItems;
  return [{ to: returnTo, label: returnLabel || 'Return' }, ...baseItems];
}
